<template>
<v-container fluid grid-list-sm pa-0 ma-0 elevation-1>
  <h4 v-if="taxCal.length>0"> Tax Summary</h4>
    <v-simple-table v-if="taxCal.length>0">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Hsn</th>
          <th class="text-left hidden-xs-only">Gst</th>
          <th class="text-right " :class="vis">Cgst</th>
          <th class="text-right" :class="vis">Sgst</th>
          <th class="text-right" v-if="taxCal[0].igst_amt">Igst</th>
          <th class="text-right">taxable value</th>
          <th class="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item  ) in taxCal" :key="item.index" >
          <td>{{ item.hsn }}</td>
          <td class="hidden-xs-only">{{ item.gst }}</td>
          <td :class="vis" class="text-right">{{ item.cgst_amt }}</td>
          <td :class="vis" class="text-right">{{ item.sgst_amt }}</td>
          <td v-if="taxCal[0].igst_amt" class="text-right">{{ item.igst_amt }}</td>
          <td class="text-right">{{ item.taxable_value }}</td>
          <td class="text-right">{{ item.total }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</v-container>
</template>

<script>
export default {
    computed: {
        taxCal() {
            // console.log( 'fom tax ' + JSON.stringify(this.$store.state.invoice.tax))
            return this.$store.getters['invoice/taxCal']
        },
        vis(){
            if (this.taxCal.length>0 && this.taxCal[0].cgst_amt)
            {
                return 
            } else return 'd-none'
        }
        //:class="{error: index % 2==0, success: index %2 !==0}"
    }
}
</script>

<style>

</style>
